export class DocumentSchemaFailedError extends Error {
	constructor(private readonly id: string, private readonly collection: string) {
		super();
		this.message = `Document schema validation failed for ${this.id} for collection ${this.collection}.`;
	}
}
